import { lazyHouseholdPage } from './lazyHouseholdPage';
const youvest = lazyHouseholdPage(() => import('../YouvestPreview'));
const planning = lazyHouseholdPage(() => import('../PlanningPreview'));

// Both Bun and legacy advisor entry points can render the feature-flagged Hub.
export const advisorHouseholdPaths = [
    '/crm/households/:household_id/advisor',
    '/crm/households/:household_id/advisor/:hubTab(meetings|one-pager)',
];

// Shared by the route renderer and idle preloader; no page imports run here.
export const householdPages = {
    overview: lazyHouseholdPage(() => import('../AdvisorBun')),
    'one-pager': lazyHouseholdPage(() => import('../OnePagerBun')),
    'net-worth': lazyHouseholdPage(() => import('../NetWorthBun')),
    spending: lazyHouseholdPage(() => import('../Budget/SpendingBun')),
    'financial-story': lazyHouseholdPage(() => import('../FinancialStoryBun')),
    notes: lazyHouseholdPage(() => import('../NotesBun')),
    vault: lazyHouseholdPage(() => import('../DocumentsBun')),
    clipboard: lazyHouseholdPage(() => import('../ClipboardBun')),
    planning: {
        Page: planning.Page,
        preload: async () => {
            const module = await planning.preload();
            await module.preloadPlanningWorkspace();
            return module;
        },
    },
    youvest: {
        Page: youvest.Page,
        preload: async (householdId) => {
            const module = await youvest.preload();
            await module.preloadYouvestWorkspace(householdId);
            return module;
        },
    },
};
